import { useState, useEffect } from 'react';

const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [connectionSpeed, setConnectionSpeed] = useState('unknown');
  const [isSlowConnection, setIsSlowConnection] = useState(false);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Check connection speed if available
    if ('connection' in navigator) {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      
      const updateConnectionInfo = () => {
        if (connection) {
          const effectiveType = connection.effectiveType || 'unknown';
          setConnectionSpeed(effectiveType);
          
          // Consider 2g and slow-2g as slow connections
          setIsSlowConnection(effectiveType === '2g' || effectiveType === 'slow-2g');
        }
      };

      updateConnectionInfo();
      
      if (connection.addEventListener) {
        connection.addEventListener('change', updateConnectionInfo);
      }

      return () => {
        window.removeEventListener('online', handleOnline);
        window.removeEventListener('offline', handleOffline);
        if (connection && connection.removeEventListener) {
          connection.removeEventListener('change', updateConnectionInfo);
        }
      };
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return {
    isOnline,
    connectionSpeed,
    isSlowConnection,
    connectionType: isSlowConnection ? 'slow' : connectionSpeed
  };
};

export default useNetworkStatus;





